import DialogContent from '@zenbusiness/zui/DialogContent';
import Stack from '@zenbusiness/zui/Stack';
import { styled } from '@zenbusiness/zui/styles';

const WrapperStyle = ({ theme }) => ({
  gridColumn: '1 / 5',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '4 / 10'
  }
});

const DialogContentStyle = ({ theme }) => ({
  padding: '0',
  backgroundColor: theme.palette.background.grey.main
});

export const Wrapper = styled(Stack)(WrapperStyle);
export const DialogContentStyled = styled(DialogContent)(DialogContentStyle);
